import { identityAccountId } from "../identity-account";

export const roomOwnerId = identityAccountId;
